module.exports = __webpack_public_path__ + "static/media/edge.f94110ef.svg";